export enum OrganisationColumnKeys {
  NAME = 'organisationName',
  ORGANISATION_NONE = 'organisationNone',
}
